import _get from 'lodash/get';

export const getPredefinedCopySourceMid = merchant =>
  _get(merchant, 'merchantCopySourceMid') ||
  _get(merchant, 'preAssessmentPrefillInfo.overrideMerchantId');
